module.exports = __webpack_public_path__ + "img/sam-and-nick.bbb8e4f9.png";